/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowDownBar = createReactComponent("outline", "arrow-down-bar", "IconArrowDownBar", [["path", { "d": "M12 3v18", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M9 3h6", "key": "svg-2" }]]);

export { IconArrowDownBar as default };
//# sourceMappingURL=IconArrowDownBar.mjs.map
